import { IPartnership } from "@rentiohq/shared-frontend/dist/redux/expertInquiry/expertInquiry.types";
import { EModals } from "./LocationDescriptionModal.types";

export const genInitialModal = (partnerships?: IPartnership[]) => {
  if (!partnerships) {
    return EModals.Intro;
  }

  if (partnerships.length === 0) {
    return EModals.Intro;
  }

  if (partnerships.length === 1) {
    // Only has MEXP
    if (partnerships[0].locationDescriptorKey === "MEXP") {
      return EModals.Intro;
    }

    // Single partner
    return EModals.Form;
  }

  // Multiple partners
  return EModals.PartnerPicker;
};
